/**
 * US states, DC and the territories, for validating what a patient types into the address step.
 *
 * The same list the web form accepted, so nobody who could book before is turned away now.
 */
export const US_STATES: ReadonlyArray<{ abbreviation: string; name: string }> = [
	{ abbreviation: 'AL', name: 'Alabama' },
	{ abbreviation: 'AK', name: 'Alaska' },
	{ abbreviation: 'AZ', name: 'Arizona' },
	{ abbreviation: 'AR', name: 'Arkansas' },
	{ abbreviation: 'CA', name: 'California' },
	{ abbreviation: 'CO', name: 'Colorado' },
	{ abbreviation: 'CT', name: 'Connecticut' },
	{ abbreviation: 'DE', name: 'Delaware' },
	{ abbreviation: 'DC', name: 'District of Columbia' },
	{ abbreviation: 'FL', name: 'Florida' },
	{ abbreviation: 'GA', name: 'Georgia' },
	{ abbreviation: 'HI', name: 'Hawaii' },
	{ abbreviation: 'ID', name: 'Idaho' },
	{ abbreviation: 'IL', name: 'Illinois' },
	{ abbreviation: 'IN', name: 'Indiana' },
	{ abbreviation: 'IA', name: 'Iowa' },
	{ abbreviation: 'KS', name: 'Kansas' },
	{ abbreviation: 'KY', name: 'Kentucky' },
	{ abbreviation: 'LA', name: 'Louisiana' },
	{ abbreviation: 'ME', name: 'Maine' },
	{ abbreviation: 'MD', name: 'Maryland' },
	{ abbreviation: 'MA', name: 'Massachusetts' },
	{ abbreviation: 'MI', name: 'Michigan' },
	{ abbreviation: 'MN', name: 'Minnesota' },
	{ abbreviation: 'MS', name: 'Mississippi' },
	{ abbreviation: 'MO', name: 'Missouri' },
	{ abbreviation: 'MT', name: 'Montana' },
	{ abbreviation: 'NE', name: 'Nebraska' },
	{ abbreviation: 'NV', name: 'Nevada' },
	{ abbreviation: 'NH', name: 'New Hampshire' },
	{ abbreviation: 'NJ', name: 'New Jersey' },
	{ abbreviation: 'NM', name: 'New Mexico' },
	{ abbreviation: 'NY', name: 'New York' },
	{ abbreviation: 'NC', name: 'North Carolina' },
	{ abbreviation: 'ND', name: 'North Dakota' },
	{ abbreviation: 'OH', name: 'Ohio' },
	{ abbreviation: 'OK', name: 'Oklahoma' },
	{ abbreviation: 'OR', name: 'Oregon' },
	{ abbreviation: 'PA', name: 'Pennsylvania' },
	{ abbreviation: 'RI', name: 'Rhode Island' },
	{ abbreviation: 'SC', name: 'South Carolina' },
	{ abbreviation: 'SD', name: 'South Dakota' },
	{ abbreviation: 'TN', name: 'Tennessee' },
	{ abbreviation: 'TX', name: 'Texas' },
	{ abbreviation: 'UT', name: 'Utah' },
	{ abbreviation: 'VT', name: 'Vermont' },
	{ abbreviation: 'VA', name: 'Virginia' },
	{ abbreviation: 'WA', name: 'Washington' },
	{ abbreviation: 'WV', name: 'West Virginia' },
	{ abbreviation: 'WI', name: 'Wisconsin' },
	{ abbreviation: 'WY', name: 'Wyoming' },
	{ abbreviation: 'AS', name: 'American Samoa' },
	{ abbreviation: 'FM', name: 'Federated States Of Micronesia' },
	{ abbreviation: 'GU', name: 'Guam' },
	{ abbreviation: 'MH', name: 'Marshall Islands' },
	{ abbreviation: 'MP', name: 'Northern Mariana Islands' },
	{ abbreviation: 'PW', name: 'Palau' },
	{ abbreviation: 'PR', name: 'Puerto Rico' },
	{ abbreviation: 'VI', name: 'Virgin Islands' },
]

const byAbbreviation = new Map(US_STATES.map((s) => [s.abbreviation, s]))
const byName = new Map(US_STATES.map((s) => [s.name.toLowerCase(), s]))

/**
 * The two-letter code for whatever the patient typed, or null when it is not a state.
 *
 * Accepts either form, as the web renderer did, so "ny", "NY" and "New York" all pass.
 */
export const normalizeState = (input: string): string | null => {
	const trimmed = input.trim()
	if (!trimmed) {
		return null
	}
	if (trimmed.length === 2) {
		return byAbbreviation.get(trimmed.toUpperCase())?.abbreviation ?? null
	}
	return byName.get(trimmed.toLowerCase())?.abbreviation ?? null
}
